/**
 * core · Níveis de acesso e a matriz (spec 03 §2 · spec 02 §1.8 · tela 10.3).
 *
 * A escada e os módulos vêm de `@dv/domain`, e não de uma lista repetida aqui: se
 * a matriz do contrato e a do motor de decisão pudessem divergir, o dia em que
 * divergissem seria o dia em que alguém salva uma permissão que o guard não aplica.
 */
import { z } from 'zod'
import { ESCADA, MODULOS } from '@dv/domain'
import { uuid } from './comum.js'

export const modulo = z.enum(MODULOS)
export const acao = z.enum(ESCADA)

export const celulaDaMatriz = z.object({
  modulo,
  acao,
  podeExcluir: z.boolean(),
  podeAprovar: z.boolean(),
  podeExportar: z.boolean(),
  escopoCarteira: z.enum(['proprios', 'todos']),
  veValoresFinanceiros: z.boolean(),
})
export type CelulaDaMatriz = z.infer<typeof celulaDaMatriz>

export const nivel = z.object({
  id: uuid,
  nome: z.string(),
  descricao: z.string().nullable(),
  semente: z.boolean(),
  /** Cabeçalho da coluna na 10.3 — quantas pessoas carregam este nível. */
  usuarios: z.number().int(),
  /** Derivado (spec 05 §9), nunca digitado: chip "2FA obrigatório" na coluna. */
  exigeDoisFatores: z.boolean(),
  matriz: z.array(celulaDaMatriz),
})
export type Nivel = z.infer<typeof nivel>

export const entradaDeNovoNivel = z.object({
  nome: z.string().min(1, 'Informe o nome.'),
  descricao: z.string().nullish(),
  /** Duplicar = criar com a matriz da origem (spec 03 §2). */
  copiarDe: uuid.nullish(),
})
export type EntradaDeNovoNivel = z.infer<typeof entradaDeNovoNivel>

export const entradaDeEdicaoDeNivel = z.object({
  nome: z.string().min(1, 'Informe o nome.').optional(),
  descricao: z.string().nullish(),
})

/**
 * A matriz vai INTEIRA numa chamada, por nível (spec 03 §2: `PUT /niveis/:id/matriz`).
 *
 * PUT e não PATCH por célula porque a tela salva um lote de pendências de uma vez e
 * a auditoria precisa registrar o diff como UM ato — trinta PATCHes deixariam
 * trinta linhas de trilha para uma decisão só.
 */
export const entradaDeMatriz = z.object({ matriz: z.array(celulaDaMatriz) })
export type EntradaDeMatriz = z.infer<typeof entradaDeMatriz>
